/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type { UpdateUserOptions, UpdateUserResponses } from '../types/UpdateUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Update user by ID (admin only)
 * {@link /v1/user/:user_id}
 */
export function updateUser<ThrowOnError extends boolean = true>(
  options: Options<UpdateUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<UpdateUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/user/{user_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<UpdateUserResponses, ThrowOnError>>,
  )
}
